<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        v-if="$ability.can('Adicionar','Leads Vendedor')"
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogFormCreate.show()"
      >
        <v-icon left>mdi-plus-circle</v-icon>Nova Lead
      </v-btn>
      <v-form>
        <v-row dense align="center">
          <v-col cols="3">
            <SelectFilterBy @onChanged="filterBy = $event; changeFilterBy($event)" />
          </v-col>
          <v-col cols="2">
            <SelectTemperatura
              @onChanged="temperatura = $event"
              :disabled="disableSelectTemperatura"
              :validate="validateSelectTemperatura"
            />
          </v-col>
          <v-col cols="2">
            <DateMenu
              label="Data Inicio"
              @onChanged="dateStart = $event"
              :disabled="disableSelectDate"
            />
          </v-col>
          <v-col cols="2">
            <DateMenu label="Data Fim" @onChanged="dateEnd = $event" :disabled="disableSelectDate" />
          </v-col>
          <v-col cols="2">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <DialogFormCreate ref="dialogFormCreate" />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Vendedor } from "@/services/lead";

export default {
  name: "Filtro",

  components: {
    SelectFilterBy: () => import("../../components/SelectFilterBy"),
    SelectTemperatura: () => import("@/components/select/SelectTemperatura"),
    DateMenu: () => import("@/components/datepicker/DateMenu"),
    DialogFormCreate: () => import("./DialogFormCreate")
  },

  data() {
    return {
      filterBy: "",
      temperatura: "",
      disableSelectTemperatura: false,
      validateSelectTemperatura: true,
      disableSelectDate: false,
      dateStart: new Date(),
      dateEnd: new Date(),
      serviceLeadsVendedor: new Vendedor()
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"])
  },

  methods: {
    ...mapActions("leads", ["setLeads"]),

    async buscar() {
      try {
        let response = [];
        if (this.filterBy == "Temperatura") {
          response = await this.serviceLeadsVendedor.getLeadsByTemperatura(
            this.getUser.cpf,
            this.temperatura
          );
        } else if (this.filterBy == "Data Criação") {
          response = await this.serviceLeadsVendedor.getLeadsByDataCriacao(
            this.getUser.cpf,
            this.dateStart,
            this.dateEnd
          );
        } else if (this.filterBy == "Data Proximo Contato") {
          response = await this.serviceLeadsVendedor.getLeadsByDataProxContato(
            this.getUser.cpf,
            this.dateStart,
            this.dateEnd
          );
        }
        this.setLeads(response);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao carregar Dados");
        return Promise.reject(error);
      }
    },

    changeFilterBy() {
      if (this.filterBy == "Temperatura") {
        this.disableSelectTemperatura = false;
        this.validateSelectTemperatura = true;
        this.disableSelectDate = true;
      } else {
        this.disableSelectTemperatura = true;
        this.validateSelectTemperatura = false;
        this.disableSelectDate = false;
      }
    }
  }
};
</script>
